import React,{ Fragment, useContext} from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { ViewerContext } from "../../context/ViewerContext";
import { LuEye, LuEyeOff  } from "react-icons/lu";
import { FiMinus } from "react-icons/fi";

export default function Layer({map}) {
    const { handelSelectLayer, showLayer, setShowLayer, showAllLayer, layerCategory } = useContext(ViewerContext);

    // sort object alpha.
    var entries = Object.entries(layerCategory);
    entries.sort((a, b) => a[0].localeCompare(b[0]));
    entries = Object.fromEntries(entries);

    return (
        <Transition.Root show={showLayer} as={Fragment}>
            <Dialog className="relative z-10" onClose={setShowLayer}>
                <div className="fixed inset-0" />

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 z-50 right-0 flex max-w-full pl-10 sm:pl-16  mt-[59px] lg:mt-[0px]  sideOver ">
                            <Transition.Child
                                as={Fragment}
                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                    <div className="flex h-full flex-col overflow-y-scroll bg-white px-2 py-14 shadow-xl">
                                        <div className="px-4">
                                            <div className="flex items-start justify-between">
                                                <Dialog.Title className="text-xl px-2 mb-6 font-semibold leading-6 text-gray-900">
                                                    Ebenen
                                                </Dialog.Title>
                                                <div className="ml-3 flex h-7 items-center">
                                                    <button
                                                        type="button"
                                                        className="relative rounded-md bg-white text-gray-900 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                                                        onClick={() => setShowLayer(false)}
                                                    >
                                                        <span className="absolute -inset-2.5" />
                                                        <span className="sr-only">Close panel</span>
                                                        <XMarkIcon className="h-9 w-9" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                            <div  className={"justify-between truncate text-gray-600 block gap-2 p-2 text-sm"}>
                                                <div
                                                     className="flex mr-2 rounded ring-white text-gray-600 ">

                                                    {(showAllLayer === true) ? (<LuEye  onClick={() => handelSelectLayer(false)} className="cursor-pointer h-5 w-5 mr-2 rounded ring-white text-gray-600 "/>): ("") }
                                                    {(showAllLayer === false) ? (<LuEyeOff  onClick={() => handelSelectLayer(true)} className="cursor-pointer h-5 w-5 mr-2 rounded ring-white text-gray-600 "/>): ("") }
                                                    {(showAllLayer === null) ? (<FiMinus  onClick={() => handelSelectLayer(true)} className="cursor-pointer h-5 w-5 mr-2 rounded ring-white text-gray-600 "/>): ("") }

                                                    <b className={"ml-2"}>Alle</b>
                                                </div>
                                            </div>

                                            <div className={"border-t-2 my-2"}></div>

                                            <ul>
                                                { (typeof entries !== "undefined") ?
                                                    Object.keys(entries).map((key, index) => {
                                                        if(entries[key]?.name !== "" ) {

                                                            return (
                                                                <li className={"mb-2"} key={index}>
                                                                    <div  className={" flex text-gray-600 block gap-2 p-2 text-sm "}>
                                                                            {(entries[key]?.visible === true) ? (<LuEye  onClick={() => handelSelectLayer(false,key)} className="hover:text-gray-900 cursor-pointer h-5 w-5 mr-2 rounded ring-white text-gray-600 "/>): ("") }
                                                                            {(entries[key]?.visible === false) ? (<LuEyeOff  onClick={() => handelSelectLayer(true,key)} className="hover:text-gray-900 cursor-pointer h-5 w-5 mr-2 rounded ring-white text-red "/>): ("") }
                                                                        <span
                                                                            className={"truncate"}
                                                                        >
                                                                            <div
                                                                                className='text-gray-600 hover:text-gray-900'
                                                                            >
                                                                                {entries[key]?.name}
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                </li>
                                                            );
                                                        } else {
                                                            return null;
                                                        }
                                                    }) : ("")
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
